<template>
    <div class="zebra-crossing-detail">
        <!-- 处理明细 -->
        <el-form>
            <div class="zebra-item">
                <div class="zebra-item_tit">表单明细</div>
                <!-- 分类 配置项编号 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="分类:">{{ detail.category && detail.category.title ? detail.category.title:''}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="配置项编号:">{{ detail.serialNumber }}</el-form-item>
                    </el-col>
                </el-row>
                <!-- 使用者 拥有者 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="拥有者:">{{ detail.owner && detail.owner.name ? detail.owner.name : ''}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="使用者:">{{ detail.user && detail.user.name ? detail.user.name :'' }}</el-form-item>
                    </el-col>
                </el-row>
                <!-- 所属公司 所属部门 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="所属公司:">{{ detail.company && detail.company.title ? detail.company.title : ''}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="所属部门:">{{ detail.department && detail.department.title ? detail.department.title : ''}}</el-form-item>
                    </el-col>
                </el-row>
                <!-- 资产类型 采购时间 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="资产类型:">{{ detail.assetType | tableVal(cmdbAssetType)}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="采购时间:">{{ detail.purchaseTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 资产成本 到货时间 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="资产成本:">{{ detail.assetCost }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="到货时间:">{{ detail.arrivalTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 环境类型 借用到期日 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="环境类型:">{{ detail.envType | tableVal(envType) }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="借用到期日:">{{ detail.borrowEndTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 型号 保修开始时间 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="型号:">{{ detail.model }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="保修开始时间:">{{ detail.warrantyStartTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 序列号 保修结束时间 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="序列号:">{{ detail.serialNum }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="保修结束时间:">{{ detail.warrantyEndTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 品牌 报废日期 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="品牌:">{{ detail.brand | tableVal(brand)}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="报废日期:">{{ detail.retireTime }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 供应商 所在位置 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="供应商:">{{ detail.supplier | tableVal(supplier)}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="所在位置:">{{ detail.place | tableVal(location) }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 物理地址 影响服务 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="物理地址:">{{ detail.physicalAddress }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="影响服务:">
                            <span v-for='(item, index) of detail.toService' :key='item.serialNumber'>
                                {{item.title}}
                                {{ detail.toService.length - 1 === index ?'': "," }}
                            </span>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 厂商联系人 文件 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="厂商联系人:">
                            <span v-for='(item, index) of detail.toUser' :key='item.userid'>
                                {{item.name}}
                                {{ detail.toUser.length - 1 === index ?'': "," }}
                            </span>
                        </el-form-item>
                    </el-col>

                </el-row>
                <!-- 描述 -->
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="描述:">
                            {{detail.description}}
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="zebra-item" v-if="showConfigPros">
                <div class="zebra-item_tit">配置属性</div>
                <!-- 结构  MAC地址 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="结构:">{{ detail.configProperties.structure }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="MAC地址:">{{ detail.configProperties.mac}}</el-form-item>
                    </el-col>
                </el-row>
                <!--IP地址-->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="IP地址:">{{  detail.configProperties.ip}}</el-form-item>
                    </el-col>


                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">处理器</div>
                <!-- 类型 型号 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="类型:">{{ detail.configProperties.cpuType }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="型号:">{{  detail.configProperties.cpuModel}}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 频率 标配数量 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="频率:">{{  detail.configProperties.cpuFrequency}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="标配数量:">{{detail.configProperties.cpuStandardizedQuantity}}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 最大数量 制程工艺 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="最大数量:">{{ detail.configProperties.cpuMaxQuantity}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="制程工艺:">{{  detail.configProperties.cpuManufacturing}}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 三级缓存 总线规格 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="三级缓存:">{{   detail.configProperties.level3Cache}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="总线规格:">{{ detail.configProperties.cpuBus}}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 核心数 线程数 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="核心数:">{{ detail.configProperties.cpuCoreNum}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="线程数:">{{detail.configProperties.cpuThreadNum}}</el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>
                <div class="zebra-item_tit">主板</div>
                <!-- 芯片组 扩展槽 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="芯片组:">{{ detail.configProperties.motherboardsChip}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="扩展槽:">{{detail.configProperties.motherboardsExpansionSlot }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">内存</div>

                <!-- 类型 容量 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="类型:">{{detail.configProperties.memoryType}}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="容量:">
                            {{detail.configProperties.memorySize}}
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 最大容量 插槽数量 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="最大容量:">
                            {{detail.configProperties.memoryMaxSize}}
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="插槽数量:">
                            {{detail.configProperties.memoryExpansionSlotNum}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">存储</div>
                <!-- 硬盘接口类型  硬盘容量 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="硬盘接口类型:">
                            {{detail.configProperties.diskType}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="硬盘容量:">
                            {{detail.configProperties.diskSize}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--硬盘描述  内部硬盘架数-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="硬盘描述:">
                            {{detail.configProperties.diskDescribe}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="内部硬盘架数:">
                            {{detail.configProperties.diskRack}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--热拔插盘位  RAID模式-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="热拔插盘位:">
                            {{detail.configProperties.diskHotSwap}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="RAID模式:">
                            {{detail.configProperties.diskRAID}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--磁盘控制器  光驱-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="磁盘控制器:">
                            {{detail.configProperties.diskControl}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="光驱:">
                            {{detail.configProperties.CDDrive}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">网络</div>
                <!--网络控制器 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="网络控制器:">
                            {{detail.configProperties.network}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">电源性能</div>
                <!--类型  数量 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="类型:">
                            {{detail.configProperties.powerType}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="数量:">
                            {{detail.configProperties.powerNum}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="功率:">
                            {{detail.configProperties.powerPower}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">外观特征</div>
                <!--尺寸  重量 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="尺寸:">
                            {{detail.configProperties.appearanceSize}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="重量:">
                            {{detail.configProperties.appearanceWeight}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row></el-row>

                <div class="zebra-item_tit">适用环境</div>
                <!--工作温度  工作湿度 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="工作温度:">
                            {{detail.configProperties.workingTemperature}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工作湿度:">
                            {{detail.configProperties.workingHumidity}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--存储温度  存储湿度 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="存储温度:">
                            {{detail.configProperties.storageTemperature}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="存储湿度:">
                            {{detail.configProperties.storageHumidity}}
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <el-form-item>

                <el-button type="default" size="small"  @click="close">关闭</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import services from './configuration.services'
    export default {

        props: {
            serialNumber: String,
            callback:Function
        },
        data(){
            return{
                detail:{},
                showConfigPros:false
            }
        },
        created(){
            // console.log(this.serialNumber);
            this.getDetail()
        },
        computed:{
            // 字典
            dictionary() {
                return this.$store.state.dictionary;
            },
            //资产类型
            cmdbAssetType() {
                return this.dictionary.cmdb_asset_type;
            },
            //环境类型
            envType() {
                return this.dictionary.env_type;
            },
            // 品牌
            brand() {
                return this.dictionary.brand;
            },
            // 供应商
            supplier() {
                return this.dictionary.supplier;
            },
            // 所在位置
            location() {
                return this.dictionary.location;
            },
        },
        methods:{
            // 获取配置项详情
            getDetail(){
                if (this.serialNumber) {
                    services.cmdbDescribe({ serialNumber: this.serialNumber})
                        .then(res => {
                            this.detail =  res;
                            this.status = this.tableVal(res.status,this.cmdbStatus)
                            if (Object.keys(res.configProperties).length==0){
                                // console.log('不存在');
                                // this.tabViews=this.tabViews.filter(item=>{
                                //     return item.name!=='配置属性'
                                // })
                                // console.log(this.tabViews);
                                this.showConfigPros=false

                            } else{
                                // console.log('存在');
                                this.showConfigPros=true
                                // console.log(this.tabViews);
                            }
                        })
                        .catch(err => this.$message.error(err.message))
                        .finally(() => this.loading = false)
                }else{
                    this.$message.error('缺少配置项编号，无法请求详情')
                }

            },
            // 设置配置项状态
            tableVal(value, arr) {
                if(!arr) return '无';
                if(arr && arr.length == 0) return "无";
                let res = arr.filter(item => item.id == value)
                if(!res.length) return '无'
                return res[0].cname;
            },
            close(){
                this.$modal.close();
                this.callback()
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
